// extracted by mini-css-extract-plugin
module.exports = {"icon":"Progress_icon__1Ufii"};